module.exports = __webpack_public_path__ + "img/8.3db71a43.jpg";